<template>
    <main>
    	<HeaderTab :title="$t('sync_groomy.demandes_synchro')" />
        <div id="content">
            <div class="container-fluid">
	            <div class="box">
	            	<div class="row">
	            		<LoadingSpinner v-if="loading" class="col-12" />
						<div v-else class="col-12 mt-2">
			                <div class="row p-3">
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.status.title') }}</h3>
			                    </div>
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.date_demande') }}</h3>
			                    </div>
			                    <div class="col-2">
			                        <h3>{{ $t('sync_groomy.sync_type') }}</h3>
			                    </div>
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.horse_sync') }}</h3>
			                    </div>
			                    <div class="col-2">
			                        <h3>{{ $t('sync_groomy.email_demandeur') }}</h3>
			                    </div>
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.tiers_demandeur') }}</h3>
			                    </div>
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.date_debut') }}</h3>
			                    </div>
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.echeance') }}</h3>
			                    </div>
			                    <div class="col-1">
			                        <h3>{{ $t('sync_groomy.date_reponse') }}</h3>
			                    </div>
			                    <div class="col-1"></div>
			                </div>
							<div class="trigger p-3 row" v-for="sync in syncs" :key="sync.synclicence_id">
			                    <div class="col-1">
			                        <b-badge v-if="sync.synclicence_status == 'ask'" pill class="p-2" variant="warning">
			                            <font-awesome-icon class="mr-1" :icon="['fal', 'clock']"/> {{ $t('sync_groomy.status.ask') }}
			                        </b-badge>
			                        <b-badge v-if="sync.synclicence_status == 'accept'" pill class="p-2" variant="success">
			                            <font-awesome-icon class="mr-1" :icon="['fal', 'check']"/> {{ $t('sync_groomy.status.accept') }}
			                        </b-badge>
			                        <b-badge v-if="sync.synclicence_status == 'refuse'" pill class="p-2" variant="danger">
			                            <font-awesome-icon class="mr-1" :icon="['far', 'times']"/> {{ $t('sync_groomy.status.refuse') }}
			                        </b-badge>
			                        <b-badge v-if="sync.synclicence_status == 'cancel'" pill class="p-2" variant="danger">
			                            <font-awesome-icon class="mr-1" :icon="['far', 'times']"/> {{ $t('sync_groomy.status.cancel') }}
			                        </b-badge>
			                    </div>
			                    <div class="col-1">
			                    	{{ sync.synclicence_inserted }}
			                    </div>
			                    <div class="col-2">
			                    	{{ $t('sync_groomy.types.'+sync.type.synctype_code) }}
			                    </div>
			                    <div class="col-1">
			                        <span v-for="horse in sync.horses" :key="horse">
			                        	{{ horse }}<br>
			                        </span>
			                    </div>
			                    <div class="col-2">
			                    	{{ sync.from_mail }}
			                    </div>
			                    <div class="col-1">
			                    	<router-link v-if="sync.synclicence_to_tiers" :to="{ name: 'tiersTableauBord', params: { tiers_id: sync.tier.tiers_id }}">{{ sync.tier.tiers_rs }}</router-link>
			                    	<a v-else href="#" @click.prevent="openTiersSelection(sync.synclicence_id)">{{ $t('sync_groomy.define_tiers') }}</a>
			                    </div>
			                    <div class="col-1">
			                    	{{ sync.synclicence_start }}
			                    </div>
			                    <div class="col-1">
			                    	{{ sync.synclicence_end }}
			                    </div>
			                    <div class="col-1">
			                    	{{ sync.synclicence_response_date }}
			                    </div>
			                    <div class="col-1">
			                    	<b-dropdown v-if="sync.synclicence_status == 'ask'" id="dropdown">
										<template v-slot:button-content>
											{{ $t('sync_groomy.answer') }} ▿
										</template>
				                    	<b-dropdown-item @click="openConfirm('accept', sync.synclicence_id)">
				                    		{{ $t('sync_groomy.action.accept.ok') }} <font-awesome-icon class="mr-1" :icon="['fal', 'check']"/> 
				                        </b-dropdown-item>
				                    	<b-dropdown-item  @click="openConfirm('refuse', sync.synclicence_id)">
				                    		{{ $t('sync_groomy.action.refuse.ok') }} <font-awesome-icon class="mr-1" :icon="['far', 'times']"/> 
				                        </b-dropdown-item>
			                    	</b-dropdown>
			                        <b-button v-else-if="sync.synclicence_status == 'accept'" variant="secondary" @click="openConfirm('cancel', sync.synclicence_id)">
			                        	{{ $t('sync_groomy.action.cancel.ok') }} <font-awesome-icon class="mr-1" :icon="['far', 'times']"/> 
			                        </b-button>
			                    </div>
							</div>
						</div>
	            	</div>
	            </div>
	        </div>
        </div>
        <ModalConfirm
            ref="modal_confirm"
            :text_title="action.trad_title"
            :text_question="action.trad_question"
            :text_message="action.trad_message"
            :text_button_ok="action.trad_ok"
            :text_button_cancel="getTrad('global.close')"
            :icon="action.icon"
            :callback_validation="confirmAction"
            :processing="processing"
        />

        <b-modal ref="modal_tiers" hide-footer>
            <template v-slot:modal-title>
                {{ $t("sync_groomy.define_tiers") }}
            </template>

            <div class="row">
            	<div class="col-12">
            		<SearchTiers 
						:tiers_selected.sync="tiers_selected"
					/>
            	</div>
                <div class="col-12 text-center">
                	<b-button class="mt-3" :disabled="!tiers_selected" variant="primary" @click.prevent="saveTiersSelection">{{ $t("global.valider") }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'check']"/></b-button>
                </div>
            </div>
        </b-modal>
    </main>
</template>

<script type="text/javascript">
	import Tiers from "@/mixins/Tiers.js"

	export default {
		name: 'SyncGroomy',
		mixins: [Tiers],
		data () {
			return {
				loading: false,
				syncs: [],
				action: {
					trad_title: '',
					trad_question: '',
					trad_message: '',
					trad_ok: '',
					icon: '',
					callback: null
				},
				synclicence_edit: 0,
				processing: false,
				tiers_selected: false
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				const syncs = await this.getSyncGroomyByLicence()
				this.syncs = syncs.map(sync => ({
                	...sync,
                	synclicence_inserted: this.formatDate(sync.synclicence_inserted),
					synclicence_start: sync.synclicence_start ? this.formatDate(sync.synclicence_start) : '',
					synclicence_end: sync.synclicence_end ? this.formatDate(sync.synclicence_end) : '',
					synclicence_response_date: sync.synclicence_response_date ? this.formatDate(sync.synclicence_response_date) : ''
                }))
				this.loading = false
			},

			async confirmAction() {
				this.processing = true
				await this.actionSyncGroomy(this.synclicence_edit, this.action.action)
				this.processing = false
            	this.$refs.modal_confirm.closeModal()
            	this.action = {
					trad_title: '',
					trad_question: '',
					trad_message: '',
					trad_ok: '',
					icon: '',
					callback: null
				}
            	this.init_component()
			},

			openConfirm(action, synclicence_id) {
				this.synclicence_edit = synclicence_id
				this.action = {
					action: action,
					trad_title: this.getTrad('sync_groomy.action.'+action+'.title'),
					trad_question: this.getTrad('sync_groomy.action.'+action+'.question'),
					trad_message: this.getTrad('sync_groomy.action.'+action+'.message'),
					trad_ok: this.getTrad('sync_groomy.action.'+action+'.ok'),
					icon: this.getTrad('sync_groomy.action.'+action+'.icon').split(',')
				}
            	this.$refs.modal_confirm.openModal()
			},

			openTiersSelection(synclicence_id) {
				this.synclicence_edit = synclicence_id
				this.tiers_selected = null
				this.$refs.modal_tiers.show()
			},

			async saveTiersSelection() {
				this.processing = true
				await this.editTiersSyncGroomy(this.synclicence_edit, this.tiers_selected.tiers_id)
				this.processing = false
				this.$refs.modal_tiers.hide()
            	this.init_component()
			}
		},

		components: {
       		HeaderTab: () => import('@/components/HeaderTab'),
        	LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
        	ModalConfirm: () => import('GroomyRoot/components/Modals/ModalConfirm'),
        	SearchTiers : () => import('@/components/Contract/SearchTiers')
		}
	}

</script>